
import commonConfig from "@/utils/common.js"
import { trackWellcomeClickEvent } from "@/utils/track"
import ALink from "@/components/aLink.vue"

export default {
  name: "WelcomeBg",
  components: {
    ALink
  },
  data() {
    return {
      categoryShow: false,
      shortenHeader: false,
      wellcomeListShow: false
    }
  },

  computed: {
    style() {
      if (this.categoryShow) {
        if (this.shortenHeader) {
          return { borderRadius: ".12rem .12rem 0 0" }
        } else {
          return { borderRadius: ".12rem .12rem .12rem 0" }
        }
      } else if (this.shortenHeader) {
        return { borderRadius: ".12rem .12rem 0 0" }
      } else {
        return { borderRadius: ".12rem" }
      }
    }
  },

  mounted() {
    this.$bus.$off("setShortenHeader")
    this.$bus.$on("setShortenHeader", this.setShortenHeader)
  },
  beforeDestroy() {
    this.$bus.$off("setShortenHeader")
  },
  methods: {
    setShortenHeader(value = false) {
      this.shortenHeader = value
    },
    handleCategoryClick() {
      this.categoryShow = !this.categoryShow
    },
    hideCategory() {
      this.categoryShow = false
    },
    handleWellcomeHover() {
      this.wellcomeListShow = true
    },
    handleWellcomeOut() {
      this.wellcomeListShow = false
    },
    goItem(item) {
      const lang = this.$i18n.locale
      const url = item[`url_${lang}`]
      if (url) {
        window.open(url)
      }
      this.handleWellcomeOut()
    },
    goItemLink(item) {
      const lang = this.$i18n.locale
      const url = item[`url_${lang}`]
      return url
    },
    trackWellcomeClickEvent,
    handleFollow(type) {
      switch (type) {
        case "facebook":
          return this.$t("common.facebookLink")
        case "ins":
          return this.$t("common.instagramLink")
        case "youtube":
          return this.$t("common.youtubeLink")
        case "storeLocator":
          return this.$t("footer.storeLocatorLink")
        case "about":
          return this.$t("footer.ourStoryLink")
        default:
          break
      }
    },
    goLink(type) {
      switch (type) {
        case "storeLocator":
          window.open(this.$t("footer.storeLocatorLink"))
          break
        case "about":
          window.open(this.$t("footer.ourStoryLink"))
          break
        default:
          break
      }
    }
  }
}
